import { createTheme } from "@mui/material/styles";

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#346E4A', // 
    },
    secondary: {
      main: '#7971CA',
    },
    background: {
      default: '#FEFEFE',
      paper: '#FFFFFF',
      paperTransparent: 'rgba(255, 255, 255, 0.9)',
    },
    error: {
      main: '#E77450',
    },
    info: {
      main: '#1679b7',
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif", // OpenAI uses Inter font
    body1: {
      lineHeight: 1.4,
    }
  },
  shape: {
    borderRadius: 8, // Softer rounded corners
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.main,
          },
        }),
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&.Mui-focused": {
            color: theme.palette.primary.main,
          },
        }),
      },
    },
  },
  spacing: 12,
};

const theme = createTheme(themeOptions);

export default theme;


// Noch ein Versuch um Maxi gleucklich zu machen
// primary: #346E4A
// primary.dark: #315A40
// primary.light: #55A05E
// primary.contrastText: #FFFFFF
// secondary: #FFFDC4
// neutral: #FEFAF7

// background.default: #F9F3F0
// background.paper: #FFFFFF
// background.paperTransparent: rgba(255, 255, 255, 0.9)




